import goBack from "./goBack.svg";
import avatarImg from "./avatar.png";
import bathroomIcon from "./bathroom.png";
import bedroomIcon from "./bedroom.png";
import chatIcon from "./chat.png";
import checkIcon from "./check-icon.png";
import closeIcon from "./close.png";
import copyIcon from "./copy.png";
import createIcon from "./create.png";
import dateIcon from "./date.png";
import deleteIcon from "./delete.png";
import depositIcon from "./deposit.png";
import editIcon from "./edit.png";
import enquiryMessageIcon from "./enquiry-messages.png";
import facebookIcon from "./facebook.png";
import filterIcon from "./filter.png";
import financeIcon from "./finance.png";
import goBackIcon from "./goBack.svg";
import goodCommunicationIcon from "./good-communication.png";
import goodManagementIcon from "./good-management.png";
import googleIcon from "./google.png";
import heartIcon from "./heart.png";
import homeIcon from "./home.png";
import imageUploadIcon from "./image-upload.png";
import instagramIcon from "./instagram.png";
import jpgIcon from "./jpg.png";
import locationIcon from "./location.png";
import logoutIcon from "./logout.png";

import maintenanceButtonIcon from "./maintenance-button.png";
import maintenanceCompletedIcon from "./maintenance-completed.png";
import maintenanceHoldIcon from "./maintenance-hold.png";
import maintenanceInProgressIcon from "./maintenance-in-progress.png";
import maintenanceLoaderIcon from "./maintenance-loader.png";
import maintenanceRequestIcon from "./maintenance-request-icon.png";
import maintenanceRequestImg from "./maintenance-request.png";
import maintenanceTotalIcon from "./maintenance-total.png";

import messageIcon from "./message.png";
import messengerIcon from "./messenger.png";
import moreIcon from "./more.png";
import moreDarkIcon from "./moreDark.png";
import paperIcon from "./paper.png";
import payPalIcon from "./paypal-icon.svg";
import parkingIcon from "./parking.png";
import pdfIcon from "./pdf.png";
import petsIcon from "./pets.png";
import phoneIcon from "./phone.png";
import playButtonIcon from "./play-button.png";
import plusIcon from "./plus.png";
import printerIcon from "./printer.png";
import profileIcon from "./profile.png";
import propertyIcon from "./property-icon.png";
import questionMarkIcon from "./question-mark.png";
import quotesIcon from "./quotes.png";
import rentSellIcon from "./rent_sell.png";
import searchIcon from "./search.png";
import securePaymentIcon from "./secure-payment.png";
import shareIcon from "./share.png";
import signinKeyIcon from "./signin-key.png";
import signupAvatarIcon from "./signup-avatar.png";
import squarefootIcon from "./squarefoot.png";
import totalTenantsIcon from "./total-tenants.png";
import twitterIcon from "./twitter.png";
import uploadIcon from "./upload.png";
import userAvatarIcon from "./user-avatar.png";
import utilitiesIcon from "./utilities.png";
import whatsappIcon from "./whatsapp.png";

//LAND ICONS
import soilIcon from "./soil.png";
import waterWavesIcon from "./water-waves.png";
import mineralIcon from "./minerals.png";
import roadAccessIcon from "./road.png";

export {
  avatarImg,
  goBack,
  bathroomIcon,
  bedroomIcon,
  chatIcon,
  checkIcon,
  closeIcon,
  copyIcon,
  createIcon,
  dateIcon,
  deleteIcon,
  depositIcon,
  editIcon,
  enquiryMessageIcon,
  facebookIcon,
  filterIcon,
  financeIcon,
  goBackIcon,
  goodCommunicationIcon,
  goodManagementIcon,
  googleIcon,
  heartIcon,
  homeIcon,
  imageUploadIcon,
  instagramIcon,
  jpgIcon,
  locationIcon,
  logoutIcon,
  maintenanceButtonIcon,
  maintenanceCompletedIcon,
  maintenanceHoldIcon,
  maintenanceInProgressIcon,
  maintenanceLoaderIcon,
  maintenanceRequestIcon,
  maintenanceRequestImg,
  maintenanceTotalIcon,
  messageIcon,
  messengerIcon,
  moreIcon,
  moreDarkIcon,
  paperIcon,
  payPalIcon,
  parkingIcon,
  pdfIcon,
  petsIcon,
  phoneIcon,
  playButtonIcon,
  plusIcon,
  printerIcon,
  profileIcon,
  propertyIcon,
  questionMarkIcon,
  quotesIcon,
  rentSellIcon,
  searchIcon,
  securePaymentIcon,
  shareIcon,
  signinKeyIcon,
  signupAvatarIcon,
  squarefootIcon,
  totalTenantsIcon,
  twitterIcon,
  uploadIcon,
  userAvatarIcon,
  utilitiesIcon,
  whatsappIcon,

  //LAND ICON
  soilIcon,
  waterWavesIcon,
  mineralIcon,
  roadAccessIcon,
};
